import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import Student from '../pages/student/student';
import Consult from '../pages/student/consult';
import ConsultDetail from '../pages/student/consult/detail';

const StudentRouter: FC = () => {
  return (
    <Switch>
      <Route path='/student/student' exact component={Student} />
      <Route path='/student/consult' exact component={Consult} />
      <Route path='/student/consult/:counselCode' exact component={ConsultDetail} />
    </Switch>
  )
}

export default StudentRouter;
